import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PartService from "../../Controller/PartController"
import { handleChange, handleSubmit } from "../../Controller/UpdatePartNotesController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import HelpSite from "../../../Common/HelpLink";
import SunTextEditor from "../../../Common/SunTextEditor";
function PartNotes({ StockID }) {
    StockID = localStorage.getItem('StockID');
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const [formData, setFormData] = useState({ vc_Notes: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const PartID = StockID;

    const fetchPartNotes = async () => {
        try {

            const data = await PartService.GetPartByID(redirectCallback, PartID);
            if (data.length > 0) {
                setFormData(data[0]);
            }
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };
    useEffect(() => {

        if (PartID > 0) {
            fetchPartNotes();
        }
        else {
            setFormData({ vc_Notes: '' });
        }
    }, [PartID]);


    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            vc_Notes: content
        });
    };

    const handleFormSubmit = async (event) => {
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        formData.PK_Stock_ID = PartID;
        const message = await handleSubmit(event, formData, setFormData, setErrors);
        if (message == "Data saved successfully") {
            setShowSuccessMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowSuccessMessage(false);
            }, 5000);
        }
        else {
            setShowErrorMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowErrorMessage(false);
            }, 5000);

        }
        window.scrollTo(0, 0);
        fetchPartNotes();
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <div className="row mb-3">
                <div className="col-sm-12" style={{ "textAlign": "right" }}>
                    

                </div>
            </div>
            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                    <label htmlFor="vc_Notes" className="col-sm-1 col-form-label">Notes:</label>
                    <div className="col-sm-11">
                        <SunTextEditor
                            value={formData.vc_Notes}
                            onChange={(content) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    vc_Notes: content,
                                }))
                            }
                        />
                        {errors.vc_Notes && <div style={{ color: 'red' }}>{errors.vc_Notes}</div>}
                    </div>
                </div>
                <div className="row" style={{ "marginLeft": "0px", "float": "right" }}>
                    <div className="col-sm-12">
                        <button type="submit" className="btn btn-primary">
                            <i className="icofont-save" aria-hidden="true"> Save

                            </i>
                        </button>

                    </div>
                </div>
            </form>
        </div>
    );
}
export default PartNotes;